import { render, staticRenderFns } from "./LoanDetailsMain.vue?vue&type=template&id=6b5551b7"
import script from "./LoanDetailsMain.vue?vue&type=script&lang=js"
export * from "./LoanDetailsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports